import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=4324196e&scoped=true&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&id=4324196e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4324196e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Heading: require('/src/components/PageHeading/Heading.vue').default,ArticleTitle: require('/src/components/Content/Article/ArticleTitle.vue').default,Video: require('/src/components/Video/Video.vue').default,VideoList: require('/src/components/Video/VideoList.vue').default,VideoSignUp: require('/src/components/Video/VideoSignUp.vue').default,FlexibleContent: require('/src/components/Content/FlexibleContent.vue').default,ContentBlock: require('/src/components/Content/ContentBlock.vue').default})
